import { render, staticRenderFns } from "./brochuredetails.vue?vue&type=template&id=e25b6928&scoped=true&"
import script from "./brochuredetails.vue?vue&type=script&lang=js&"
export * from "./brochuredetails.vue?vue&type=script&lang=js&"
import style0 from "./brochuredetails.vue?vue&type=style&index=0&id=e25b6928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25b6928",
  null
  
)

export default component.exports